<template>
    <div>
      <span v-if="false" class="contact-support" @click="openChat">{{ label }}&nbsp;&nbsp;</span>
      <div v-if="visible" class="chat-window" :class="{'maximized': isMaximized}">
        <div class="chat-header">
          <span class="header-title">{{ title }}</span>
          <div class="header-buttons">
            <button @click="toggleMaximize">{{ isMaximized ? '⤢' : '⤢' }}</button>
            <button @click="closeChat">✖</button>
          </div>
        </div>
        <div class="chat-body">
          <div v-for="(message, index) in messages" :key="index" :class="{'user-message-wrapper': message.isUser, 'chat-message-wrapper': !message.isUser}">
            <div class="chat-message" :class="{'user-message': message.isUser}">
              <template v-if="message.type === 'text'">
                <p>{{ message.content }}</p>
              </template>
              <template v-else-if="message.type === 'image'">
                <img :src="message.content" @click="showImage(message.content)" class="chat-image" />
              </template>
              <template v-else-if="message.type === 'file'">
                <a :href="message.content" target="_blank" class="chat-file">文件下载</a>
              </template>
            </div>
          </div>
        </div>
        <div class="chat-input">
          <input type="file" @change="handleFileUpload" ref="fileInput" style="display: none;" />
          <div class="upload-icon" @click="triggerFileInput"></div>
          <textarea v-model="newMessage" placeholder="输入消息..." />
          <button @click="sendMessage" class="send-button">发送</button>
        </div>
        <div v-if="imageViewerVisible" class="image-viewer" @click="closeImageViewer">
          <img :src="imageViewerSrc" />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import AWS from 'aws-sdk';
  
  export default {
    name: 'ChatWindow',
    props: {
      label: {
        type: String,
        default: '客服'
      },
      title: {
        type: String,
        default: '联系客服'
      }
    },
    data() {
      return {
        visible: false,
        isMaximized: false,
        messages: [
          { type: 'text', content: '你好，有什么我可以帮你的吗？', isUser: false },
          { type: 'text', content: '我想咨询一下产品的使用方法。我想咨询一下产品的使用方法。我想咨询一下产品的使用方法。我想咨询一下产品的使用方法。', isUser: true },
          { type: 'image', content: 'https://via.placeholder.com/150', isUser: false },
          { type: 'text', content: '请看这个图片示例。', isUser: false }
        ],
        newMessage: '',
        imageViewerVisible: false,
        imageViewerSrc: ''
      };
    },
    methods: {
      openChat() {
        this.visible = true;
      },
      closeChat() {
        this.visible = false;
      },
      sendMessage() {
        if (this.newMessage.trim() !== '') {
          this.messages.push({ type: 'text', content: this.newMessage, isUser: true });
          this.newMessage = '';
          this.scrollToBottom();
        }
      },
      handleFileUpload(event) {
        const file = event.target.files[0];
        if (file) {
          const s3 = new AWS.S3({
            accessKeyId: 'YOUR_AWS_ACCESS_KEY_ID',
            secretAccessKey: 'YOUR_AWS_SECRET_ACCESS_KEY',
            region: 'YOUR_AWS_REGION'
          });
          const params = {
            Bucket: 'YOUR_BUCKET_NAME',
            Key: file.name,
            Body: file,
            ACL: 'public-read'
          };
          s3.upload(params, (err, data) => {
            if (err) {
              console.error(err);
            } else {
              const fileUrl = data.Location;
              const fileType = file.type.startsWith('image/') ? 'image' : 'file';
              this.messages.push({ type: fileType, content: fileUrl, isUser: true });
              this.scrollToBottom();
            }
          });
        }
      },
      triggerFileInput() {
        this.$refs.fileInput.click();
      },
      showImage(src) {
        this.imageViewerSrc = src;
        this.imageViewerVisible = true;
      },
      closeImageViewer() {
        this.imageViewerVisible = false;
      },
      toggleMaximize() {
        this.isMaximized = !this.isMaximized;
        this.scrollToBottom();
      },
      scrollToBottom() {
        this.$nextTick(() => {
          const chatBody = this.$el.querySelector('.chat-body');
          chatBody.scrollTop = chatBody.scrollHeight;
        });
      }
    }
  }
  </script>
  
  <style scoped>
  .contact-support {
    color: #007bff;
    font-size: 0.8rem;
    cursor: pointer;
    padding-right: 1rem;
  }
  
  .chat-window {
    position: fixed;
    bottom: 0;
    right: 0;
    width: 300px;
    max-width: 100%;
    height: 400px;
    max-height: 100%;
    border: 1px solid #ccc;
    background: white;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    transition: all 0.3s ease;
  }
  
  .chat-window.maximized {
    width: 95%;
    height: 95%;
    bottom: 2.5%;
    right: 2.5%;
  }
  
  .chat-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem;
    border-bottom: 1px solid #ccc;
    background: #f5f5f5;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  
  .header-title {
    font-size: 1rem;
    flex: 1;
    padding-left: 0.5rem;
  }
  
  .header-buttons button {
    background: none;
    border: none;
    font-size: 1rem;
    cursor: pointer;
    margin-left: 0.5rem;
  }
  
  .chat-body {
    flex: 1;
    padding: 0.5rem;
    overflow-y: auto;
    font-size: 0.8rem;
    display: flex;
    flex-direction: column;
  }
  
  .chat-message-wrapper {
    display: flex;
    justify-content: flex-start;
    line-height: 1.5rem;
    margin-bottom: 10px;
  }
  
  .user-message-wrapper {
    justify-content: flex-end;
  }
  
  .chat-message {
    padding: 10px;
    margin-top: 4px;
    border-radius: 8px;
    background: #f1f1f1;
    max-width: 60%;
    word-wrap: break-word;
  }
  
  .user-message {
    background: #d1e7dd;
    float:right;
    line-height: 1.5rem;
  }
  
  .chat-image {
    max-width: 100px;
    border-radius: 4px;
    cursor: pointer;
    display: block;
    margin-top: 0.5rem;
  }
  
  .chat-input {
    display: flex;
    align-items: center;
    padding: 0.5rem;
    border-top: 1px solid #ccc;
    background: #f5f5f5;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
  
  .chat-input textarea {
    flex: 1;
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-left: 0.5rem;
    resize: none;
    height: 40px; /* 初始高度 */
  }
  
  .send-button {
    padding: 0.5rem 1rem;
    border: none;
    background: #007bff;
    color: white;
    border-radius: 4px;
    cursor: pointer;
    margin-left: 0.5rem;
  }
  
  .upload-icon {
    width: 24px;
    height: 24px;
    cursor: pointer;
    background: url("../../static/mobile_img/addimg.png") no-repeat center center;
    background-size: cover;
  }
  
  .image-viewer {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
  }
  
  .image-viewer img {
    max-width: 95%;
    max-height: 95%;
    border: 5px solid white;
    border-radius: 8px;
  }
  </style>
  


// WEBPACK FOOTER //
// src/component/ChatWindow.vue